import { element } from '../../../core/elements';
import { Arc } from '../../../primitives/shape/Arc';
import { donutChartEvents } from '../chart-events';
import { useEventMark } from '../hooks/useEventMark';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DonutMarks = element(function DonutMarks(_ref) {
  let {
    arcs,
    labelAccessor
  } = _ref;
  const {
    getActiveMark
  } = useEventMark({
    tooltip: donutChartEvents.tooltip,
    legend: donutChartEvents.legend,
    labelAccessor
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: arcs.map((arc, i) => {
      const activeMark = getActiveMark();
      const isActive = activeMark === labelAccessor(arc.data);
      return /*#__PURE__*/_jsx(Arc, {
        ariaLabel: arc.ariaLabel,
        datum: arc.data,
        innerRadius: arc.innerRadius,
        outerRadius: isActive ? arc.outerRadius + arc.outerRadius * 0.03 : arc.outerRadius,
        opacity: !activeMark || isActive ? 1 : 0.4,
        startAngle: arc.startAngle,
        endAngle: arc.endAngle,
        padAngle: arc.padAngle,
        fill: arc.fill,
        transition: `opacity .3s, d .3s`
      }, `Stack-${arc.key}-${i}`);
    })
  });
});